/*
 * Copyright (c) Nexign, JSC, 2024-2025.
 */
/**
 *
 *
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.29.0
 */

import styled from 'styled-components';

import { ImgStyled } from '@/main/components/common/Block/Img';

export const CreateInquiryModalCloseIconStyled = styled(ImgStyled)`
    width: 16px;
    height: 16px;
    cursor: pointer;
`;

export const TitleTextWithInstructionLinkStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
`
